import { render, staticRenderFns } from "./ArtigosStrategyDialog.vue?vue&type=template&id=d0cef728&scoped=true&"
import script from "./ArtigosStrategyDialog.vue?vue&type=script&lang=js&"
export * from "./ArtigosStrategyDialog.vue?vue&type=script&lang=js&"
import style0 from "./ArtigosStrategyDialog.vue?vue&type=style&index=0&id=d0cef728&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cef728",
  null
  
)

export default component.exports